import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, unref as _unref, withModifiers as _withModifiers, withCtx as _withCtx, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "sm:mt-8",
  "x-cloak": "",
  "x-data": "dropdown"
}
const _hoisted_2 = { class: "grid grid-cols-1 gap-3 mt-1" }
const _hoisted_3 = {
  key: 0,
  class: "fixed inset-0 z-10 overflow-y-auto",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_4 = { class: "flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_5 = { class: "relative inline-block px-4 pt-5 pb-4 overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6" }
const _hoisted_6 = { class: "sm:flex sm:items-start" }
const _hoisted_7 = { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" }
const _hoisted_8 = { class: "flex items-center mt-2" }
const _hoisted_9 = {
  key: 0,
  class: "mt-2 text-sm text-red-700"
}
const _hoisted_10 = { class: "mt-5 sm:mt-4 sm:ml-10 sm:pl-4 sm:flex" }
const _hoisted_11 = {
  key: 1,
  class: "fixed inset-0 z-10 overflow-y-auto",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_12 = { class: "flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_13 = { class: "relative inline-block px-4 pt-5 pb-4 overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6" }
const _hoisted_14 = { class: "sm:flex sm:items-start" }
const _hoisted_15 = { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" }
const _hoisted_16 = { class: "flex items-center mt-2" }
const _hoisted_17 = {
  key: 0,
  class: "mt-2 text-sm text-red-700"
}
const _hoisted_18 = { class: "mt-5 sm:mt-4 sm:ml-10 sm:pl-4 sm:flex" }
const _hoisted_19 = { class: "mt-6" }
const _hoisted_20 = {
  id: "form-signup",
  class: "space-y-6"
}
const _hoisted_21 = { class: "mt-1" }
const _hoisted_22 = { class: "grid grid-cols-3 mt-0 gap-x-4" }
const _hoisted_23 = { class: "" }
const _hoisted_24 = { class: "mt-2" }
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "" }
const _hoisted_27 = { class: "mt-2" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "" }
const _hoisted_30 = { class: "mt-2" }
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "flex items-center justify-between" }
const _hoisted_33 = { class: "flex items-center" }
const _hoisted_34 = { class: "mx-auto mt-1 text-center" }
const _hoisted_35 = {
  key: 0,
  class: "mt-2 text-sm text-red-700"
}

import {computed, Ref, ref} from "vue";
import {client} from '@/shared';
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import {SignupNewUser, SignupNewUserResponse} from "@/dtos";
import {VueRecaptcha} from "vue-recaptcha";
import SaButton from "@/main/components/SaButton.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'SignUp',
  setup(__props) {

const openFacebookModal = ref(false);
const openGoogleModal = ref(false);
const signUpWithSocial = async (socialType: string) => {
    attemptedToSubmit.value = true;
    if (request.value.agreeToTerms) {
        window.location.href = `/api/auth/${socialType}`;
    }
};

const openEmailOption = ref(false);
const toggleEmailOption = async () => {
  openEmailOption.value = !openEmailOption.value;
}

const attemptedToSubmit = ref(false);
const displayMustAgreeToTerms = computed(() => {
    return attemptedToSubmit.value && !request.value.agreeToTerms;
});

const request = ref(new SignupNewUser({
    email: '',
    dob: '',
    agreeToTerms: false
}));

const isSubmitting = ref(false);
const signUpSuccessful: Ref<Boolean> = ref(false);
const responseStatus = ref({});

const signUp = async () => {
    attemptedToSubmit.value = true;
    if (!request.value.agreeToTerms) {
        return;
    }
    isSubmitting.value = true;
    request.value.dob = formattedDate;
    request.value.gRecaptchaResponse = gRecaptchaResponse.value;

    await client.post<SignupNewUserResponse>(request.value)
        .then(response => {
            signUpSuccessful.value = true;
            responseStatus.value = {};
            location.href =  response.redirectUrl;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            recaptcha.value.reset();
        });
    isSubmitting.value = false;
}

const recaptcha = ref(null);
const gRecaptchaResponse = ref('');

const siteKey = computed(() => {
    return '6Lf2aEMUAAAAAM-OcLydSmjTdZFjbztBs7p7tMHp';
});

const handleError = () => {
    // Do some validation
};

const handleSuccess = (response: string) => {
    gRecaptchaResponse.value = response;
};

// Get the current year
const currentYear = new Date().getFullYear();

// Reactive variables
const selectedYear = ref("");
const selectedMonth = ref("");
const selectedDay = ref("");

const years = Array.from({ length: 100 }, (_, i) => currentYear - i).filter(
    (year) => year <= currentYear
);

// Month names
const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

// Compute days in the selected month and year
const daysInMonth = computed(() => {
    if (!selectedYear.value && !selectedMonth.value) {
        // Default to 31 days when no month or year is selected
        return Array.from({ length: 31 }, (_, i) => i + 1);
    }
    const year = selectedYear.value || currentYear; // Default to current year
    const month = selectedMonth.value || 1; // Default to January
    return Array.from(
        { length: new Date(year, month, 0).getDate() },
        (_, i) => i + 1
    );
});

// Format the selected date as mm/dd/yyyy
const formattedDate = computed(() => {
    if (!selectedYear.value || !selectedMonth.value || !selectedDay.value)
        return null;
    const month = String(selectedMonth.value).padStart(2, "0"); // Ensure 2 digits
    const day = String(selectedDay.value).padStart(2, "0");     // Ensure 2 digits
    const year = selectedYear.value;
    return `${month}/${day}/${year}`;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (openFacebookModal.value = true)),
              class: "inline-flex justify-center w-full px-4 py-2 text-xl font-medium bg-white border rounded-md shadow-sm text-clay-800 border-clay-500 hover:bg-gray-50"
            }, _cache[13] || (_cache[13] = [
              _createElementVNode("img", {
                src: "/public/assets/img/fb.png",
                class: "h-5",
                alt: "facebook logo"
              }, null, -1),
              _createElementVNode("span", { class: "ml-3 text-sm" }, "Continue with Facebook", -1)
            ]))
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (openGoogleModal.value = true)),
              class: "inline-flex justify-center w-full px-4 py-2 text-xl font-medium bg-white border rounded-md shadow-sm text-clay-800 border-clay-500 hover:bg-gray-50"
            }, _cache[14] || (_cache[14] = [
              _createElementVNode("img", {
                src: "/public/assets/img/google.svg",
                class: "h-5",
                alt: "google logo"
              }, null, -1),
              _createElementVNode("span", { class: "ml-3 text-sm" }, "Continue with Google", -1)
            ]))
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              onClick: toggleEmailOption,
              type: "button",
              "aria-expanded": "false",
              class: "inline-flex justify-center w-full px-4 py-2 text-xl font-medium bg-white border rounded-md shadow-sm text-clay-800 border-clay-500 hover:bg-gray-50"
            }, _cache[15] || (_cache[15] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                "stroke-width": "1.5",
                stroke: "currentColor",
                class: "h-5"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
                })
              ], -1),
              _createElementVNode("span", { class: "ml-3 text-sm" }, "Sign up with email", -1)
            ]))
          ])
        ])
      ]),
      (openFacebookModal.value === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[20] || (_cache[20] = _createElementVNode("div", {
                class: "fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75",
                "aria-hidden": "true"
              }, null, -1)),
              _cache[21] || (_cache[21] = _createElementVNode("span", {
                class: "hidden sm:inline-block sm:align-middle sm:h-screen",
                "aria-hidden": "true"
              }, "​", -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[19] || (_cache[19] = _createElementVNode("div", { class: "flex items-center justify-center w-12 h-12 mx-auto bg-gray-100 rounded-full shrink-0 sm:mx-0 sm:h-10 sm:w-10" }, [
                    _createElementVNode("i", {
                      "aria-hidden": "true",
                      class: "fab fa-facebook"
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_7, [
                    _cache[18] || (_cache[18] = _createElementVNode("h3", {
                      class: "text-lg font-medium leading-6 text-gray-900",
                      id: "modal-title"
                    }, "Sign Up with Facebook", -1)),
                    _createElementVNode("div", _hoisted_8, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((request.value.agreeToTerms) = $event)),
                        name: "agreeToTerms",
                        type: "checkbox",
                        class: "w-4 h-4 text-gray-600 border-2 border-gray-500 rounded focus:ring-slate-600"
                      }, null, 512), [
                        [_vModelCheckbox, request.value.agreeToTerms]
                      ]),
                      _cache[16] || (_cache[16] = _createElementVNode("label", {
                        for: "agreeToTerms",
                        class: "block mt-1 ml-4 text-sm text-clay-800"
                      }, [
                        _createTextVNode(" I am at least 16 years old, and I accept the StageAgent "),
                        _createElementVNode("a", {
                          href: "/pages/terms",
                          target: "_blank",
                          class: "underline"
                        }, " Terms of Service "),
                        _createTextVNode("  &  "),
                        _createElementVNode("a", {
                          href: "/pages/privacy",
                          target: "_blank",
                          class: "underline"
                        }, " Privacy Policy "),
                        _createTextVNode(". ")
                      ], -1))
                    ]),
                    (displayMustAgreeToTerms.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[17] || (_cache[17] = [
                          _createElementVNode("span", { class: "card-text" }, " Must agree to Terms of Service & Privacy Policy ", -1)
                        ])))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    id: "btn-signup-fb",
                    type: "submit",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (signUpWithSocial('facebook'))),
                    class: "inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-red-600 border border-transparent rounded-md shadow-sm disabled:opacity-75 hover:bg-red-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:w-auto sm:text-sm"
                  }, " Continue "),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (openFacebookModal.value = false)),
                    class: "inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border rounded-md shadow-sm border-clay-500 hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  }, " Cancel ")
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (openGoogleModal.value === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[26] || (_cache[26] = _createElementVNode("div", {
                class: "fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75",
                "aria-hidden": "true"
              }, null, -1)),
              _cache[27] || (_cache[27] = _createElementVNode("span", {
                class: "hidden sm:inline-block sm:align-middle sm:h-screen",
                "aria-hidden": "true"
              }, "​", -1)),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[25] || (_cache[25] = _createElementVNode("div", { class: "flex items-center justify-center w-12 h-12 mx-auto bg-gray-100 rounded-full shrink-0 sm:mx-0 sm:h-10 sm:w-10" }, [
                    _createElementVNode("i", {
                      "aria-hidden": "true",
                      class: "fab fa-google"
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _cache[24] || (_cache[24] = _createElementVNode("h3", {
                      class: "text-lg font-medium leading-6 text-gray-900",
                      id: "modal-title"
                    }, "Sign Up with Google", -1)),
                    _createElementVNode("div", _hoisted_16, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((request.value.agreeToTerms) = $event)),
                        name: "agreeToTerms",
                        type: "checkbox",
                        class: "w-4 h-4 text-gray-600 border-2 border-gray-500 rounded focus:ring-slate-600"
                      }, null, 512), [
                        [_vModelCheckbox, request.value.agreeToTerms]
                      ]),
                      _cache[22] || (_cache[22] = _createElementVNode("label", {
                        for: "agreeToTerms",
                        class: "block mt-1 ml-4 text-sm text-clay-800"
                      }, [
                        _createTextVNode(" I am at least 16 years old, and I accept the StageAgent "),
                        _createElementVNode("a", {
                          href: "/pages/terms",
                          target: "_blank",
                          class: "underline"
                        }, " Terms of Service "),
                        _createTextVNode("  &  "),
                        _createElementVNode("a", {
                          href: "/pages/privacy",
                          target: "_blank",
                          class: "underline"
                        }, " Privacy Policy "),
                        _createTextVNode(". ")
                      ], -1))
                    ]),
                    (displayMustAgreeToTerms.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[23] || (_cache[23] = [
                          _createElementVNode("span", { class: "card-text" }, " Must agree to Terms of Service & Privacy Policy ", -1)
                        ])))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    id: "btn-signup-google",
                    type: "submit",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (signUpWithSocial('google'))),
                    class: "inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-red-600 border border-transparent rounded-md shadow-sm disabled:opacity-75 hover:bg-red-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:w-auto sm:text-sm"
                  }, " Continue "),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (openGoogleModal.value = false)),
                    class: "inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border rounded-md shadow-sm border-clay-500 hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  }, " Cancel ")
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createVNode(ErrorSummary, { "response-status": responseStatus.value }, null, 8, ["response-status"]),
        _createElementVNode("div", null, [
          _cache[28] || (_cache[28] = _createElementVNode("label", {
            for: "email",
            class: "block text-sm font-semibold"
          }, " Email ", -1)),
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((request.value.email) = $event)),
              id: "email",
              name: "email",
              type: "email",
              autocomplete: "email",
              placeholder: "Email",
              required: "",
              class: "block w-full px-3 py-2 placeholder-gray-400 border rounded-md shadow-sm appearance-none border-clay-500 focus:outline-hidden focus:ring-slate-500 focus:border-slate-500 sm:text-sm"
            }, null, 512), [
              [_vModelText, request.value.email]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "col-span-3 text-sm font-semibold" }, "When is your birthday?", -1)),
          _cache[34] || (_cache[34] = _createElementVNode("div", { class: "col-span-3 mt-1 text-xs italic text-clay-800" }, " Your birthdate won't be stored or displayed publicly ", -1)),
          _createElementVNode("div", _hoisted_23, [
            _cache[30] || (_cache[30] = _createElementVNode("label", {
              for: "country",
              class: "block font-medium text-gray-900 sr-only text-sm/6"
            }, "Month", -1)),
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((selectedMonth).value = $event)),
                id: "month",
                name: "month",
                title: "birth month field",
                class: "block w-full rounded-md border-0 py-1.5 text-clay-900 shadow-sm ring-1 ring-inset ring-clay-500 focus:ring-2 focus:ring-inset focus:ring-clay-600 sm:max-w-xs sm:text-sm/6 px-2"
              }, [
                _cache[29] || (_cache[29] = _createElementVNode("option", {
                  disabled: "",
                  value: "",
                  selected: "",
                  hidden: ""
                }, "Month", -1)),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(months, (month, index) => {
                  return _createElementVNode("option", {
                    key: index,
                    value: index + 1
                  }, _toDisplayString(month), 9, _hoisted_25)
                }), 64))
              ], 512), [
                [_vModelSelect, selectedMonth.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedDay).value = $event)),
                id: "day",
                name: "day",
                title: "birth day field",
                class: "block w-full rounded-md border-0 py-1.5 text-clay-900 shadow-sm ring-1 ring-inset ring-clay-500 focus:ring-2 focus:ring-inset focus:ring-clay-600 sm:max-w-xs sm:text-sm/6 px-2"
              }, [
                _cache[31] || (_cache[31] = _createElementVNode("option", {
                  disabled: "",
                  value: "",
                  selected: "",
                  hidden: ""
                }, "Day", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(daysInMonth.value, (day) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: day,
                    value: day
                  }, _toDisplayString(day), 9, _hoisted_28))
                }), 128))
              ], 512), [
                [_vModelSelect, selectedDay.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((selectedYear).value = $event)),
                id: "year",
                name: "year",
                title: "birth year field",
                class: "block w-full rounded-md border-0 py-1.5 text-clay-900 shadow-sm ring-1 ring-inset ring-clay-500 focus:ring-2 focus:ring-inset focus:ring-clay-600 sm:max-w-xs sm:text-sm/6 px-2"
              }, [
                _cache[32] || (_cache[32] = _createElementVNode("option", {
                  disabled: "",
                  value: "",
                  selected: "",
                  hidden: ""
                }, "Year", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(years), (year) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: year,
                    value: year
                  }, _toDisplayString(year), 9, _hoisted_31))
                }), 128))
              ], 512), [
                [_vModelSelect, selectedYear.value]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((request.value.agreeToTerms) = $event)),
              id: "agreeToTerms",
              name: "agreeToTerms",
              type: "checkbox",
              class: "w-4 h-4 border-2 border-gray-500 rounded text-slate-800 focus:ring-slate-500"
            }, null, 512), [
              [_vModelCheckbox, request.value.agreeToTerms]
            ]),
            _cache[35] || (_cache[35] = _createElementVNode("label", {
              for: "agreeToTerms",
              class: "block ml-4 text-sm text-gray-900"
            }, [
              _createTextVNode(" I accept StageAgent’s "),
              _createElementVNode("a", {
                href: "/pages/terms",
                target: "_blank",
                class: "underline"
              }, " Terms of Service "),
              _createTextVNode("  &  "),
              _createElementVNode("a", {
                href: "/pages/privacy",
                target: "_blank",
                class: "underline"
              }, " Privacy Policy "),
              _createTextVNode(". "),
              _createElementVNode("br")
            ], -1))
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_unref(VueRecaptcha), {
              class: "inline-block mx-auto text-center g-recaptcha w-100 captcha-container",
              ref_key: "recaptcha",
              ref: recaptcha,
              sitekey: siteKey.value,
              "load-recaptcha-script": true,
              onVerify: handleSuccess,
              onError: handleError
            }, null, 8, ["sitekey"])
          ])
        ]),
        (displayMustAgreeToTerms.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, _cache[36] || (_cache[36] = [
              _createElementVNode("span", { class: "card-text" }, " Must agree to Terms of Service & Privacy Policy ", -1)
            ])))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createVNode(SaButton, {
            onClick: _withModifiers(signUp, ["prevent"]),
            loading: isSubmitting.value,
            variant: "primary"
          }, {
            loading: _withCtx(() => _cache[37] || (_cache[37] = [
              _createTextVNode(" Submitting... ")
            ])),
            default: _withCtx(() => [
              _cache[38] || (_cache[38] = _createTextVNode(" Verify Email "))
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ], 512), [
      [_vShow, openEmailOption.value]
    ]),
    _cache[39] || (_cache[39] = _createStaticVNode("<div class=\"mt-6 mb-3 text-center\"><p class=\"mb-4 text-clay-800\">Already a member? <a class=\"font-medium underline hover:text-clay-950\" href=\"/login\">Log in</a></p><p class=\"mb-4 text-sm text-clay-800\"> Creating a StageAgent account for your child?<br><a class=\"font-medium underline hover:text-clay-950\" href=\"https://help.stageagent.org/article/128-how-do-i-sign-up-my-child-for-stageagent\" target=\"_blank\">Learn more</a></p></div>", 1))
  ]))
}
}

})